import { WalletMultiButton } from '@solana/wallet-adapter-react-ui'
import React from 'react'

export function WalletConnectButton() {
  return (
    <WalletMultiButton />
  )
}
